import $ from "jquery";
import AOS from 'aos';
import ScrollMagic from 'scrollmagic';

import "aos/dist/aos.js";

import "../scss/page.scss";

import "../scss/outsourcing-offer.scss";

// import "jquery-match-height";

import "./scripts/dm-marketing/navbar.js";
import "./scripts/slick-carousel.js";
import "./scripts/scroll-magic/teams.js";
import "./scripts/outsourcing-carousel.js";
// import "./scripts/dynamicareas.js";
// import "./scripts/slick-carousel.js";

